import styled, { css } from 'styled-components';

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${theme.sz.s20} ${theme.sz.s4} ${theme.sz.s24};

    @media (min-width: ${theme.sz.md}) {
      padding-top: ${theme.sz.s24};
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    text-align: center;
    color: ${theme.co.secondary20};
    font-family: ${theme.DEPRECATED_ty.boing};
    font-weight: ${theme.DEPRECATED_ty.bold};
    font-size: ${theme.sz.s8};
    line-height: 125%;

    @media (min-width: ${theme.sz.md}) {
      font-size: ${theme.DEPRECATED_ty.displaySmall};
    }
  `,
);

export const SubTitle = styled.div(
  ({ theme }) => css`
    text-align: center;
    color: ${theme.co.secondary20};
    padding-top: ${theme.sz.s4};
    font-size: ${theme.DEPRECATED_ty.larger};

    @media (min-width: ${theme.sz.md}) {
      font-size: ${theme.DEPRECATED_ty.large};
    }
  `,
);

export const BlockItems = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    padding-top: ${theme.sz.s14};

    @media (min-width: 1152px) {
      flex-direction: row;
    }
  `,
);

export const CTA = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary20};
    margin-top: ${theme.sz.s16};
  `,
);
